import { useEffect } from 'react';

import { ChatMessage } from 'shared/interfaces/ChatMessage';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

export function useSetWelcomeMessage(
  setMessages: React.Dispatch<React.SetStateAction<ChatMessage[]>>,
  smartAssistant?: SmartAssistant
) {
  useEffect(() => {
    if (!smartAssistant) return;

    const welcomeMessageText = smartAssistant.welcomeMessage;
    setMessages((prevMessages) => {
      if (prevMessages.length > 0) return prevMessages;
      return [{ text: welcomeMessageText, fromUser: false }, ...prevMessages];
    });
  }, [smartAssistant]);
}
